import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { GeboorteDatumIcon } from "../../atoms/icons/GeboorteDatumIcon";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<Date | null>;
export const GeboorteDatum = (props: AllProps) => {
    const formatDate = (date: Date | null) => {
        return date ? new Date(date).toLocaleDateString() : '-';
    };

    return (<Caption {...props} caption={props.label || "Geboortedatum"} icon={<GeboorteDatumIcon />}>
        {formatDate(props.value)}
    </Caption>)
}

